export default __webpack_public_path__ + "static/media/pheonix.d614f784.png";